<style lang="less" scoped>

    .elements {
        list-style: none;


        li {
            padding: 10px;
          &:hover {
            background-color: silver;
          }
        }

        li div  {
            display: inline-block;
            cursor: pointer;
        }

        li .checkbox {
           padding-right: 20px;
        }
    }
</style>

<template>
    <div v-if="sortedElements.length>0"><h2>{{group.displayname}}</h2>

    <ul class="elements">
        <template v-for="element in sortedElements" v-bind:key="element.value">
            <li @click="element.checked = !element.checked" >
                <div class="checkbox"><input type="checkbox" v-model="element.checked" ></div>
                <div class="description">
                    {{element.name}} <span class="filecount">({{element.count}} / {{element.size}})</span>
                </div>
            </li>
        </template>
    </ul>
    </div>
</template>

<script>
    export default {
        props: {
            group: null,
            elements: null,
        },
        computed: {
            sortedElements: function(){
                return this.elements.slice().filter(a => {
                    return !a.removed && a.group === this.group.name && a.count > 0;
                }).sort((a, b) => {
                    return a.name.localeCompare(b.name);
                });
            }
        }
    };
</script>
